import _ from "lodash";
import draftToHtml from "draftjs-to-html";
import { fetchApi, toObject } from "../../utils";

const mapField = item => {
  return {
    ...item,
    id: _.get(item, "id"),
    candidate: _.reduce(
      _.get(item, "candidate"),
      (result, value, language) => {
        return {
          ...result,
          [language]: draftToHtml(value)
        };
      },
      {}
    ),
    benefits: _.reduce(
      _.get(item, "benefits"),
      (result, value, language) => {
        return {
          ...result,
          [language]: draftToHtml(value)
        };
      },
      {}
    ),
    available: _.get(item, 'positions_num'),
    name: _.get(item, 'name'),
  };
};

const fetchCareerPositionApi = () => {
  return fetchApi("career_positions")
    .then(res => _.get(res, "data"))
    // .then(mapField);
    .then(items => _.map(items, mapField))
    .then(toObject);
};

export { fetchCareerPositionApi };



// WEBPACK FOOTER //
// ./src/services/page/careerpositions.js